import { get } from 'lodash';

const styles = ({ margin, theme, color }) => ({
  categoryRolesHelpText: {
    marginTop: 16,
    whiteSpace: 'pre-line',
  },
  enforceRulesContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  managementContainer: {
    margin: get(margin, 'm36'),
  },
  usageRadioGroup: {
    marginLeft: 36,
  },
  formSelectContainerClass: {
    display: 'flex',
    width: 380,
    alignItems: 'center',
    height: 30,
  },
  selectFieldClass: {
    marginLeft: 10,
    width: '70% !important',
  },
  labelClass: {
    marginRight: 30,
    marginTop: 5,
    width: '30% !important',
  },
  detailDivider: {
    height: 1,
    width: '100%',
    borderTop: `2px solid ${get(theme, 'color.borderColor')}`,
  },
  usageGroup: {
    display: 'block',
    marginLeft: 36,
  },
  paper: {
    paddingRight: '20px',
    marginTop: '20px',
  },
  helpIconContainer: {
    display: 'flex',
  },
  helpIcon: {
    fontSize: 20,
    margin: get(margin, 'm2'),
    verticalAlign: 'middle',
    cursor: 'pointer',
    color: `${get(color, 'link')} !important`,
  },
});
  
export default styles;
